import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierSorenirController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierSorenirController.php
* @route '/api/partners/fetch-sorenir/{dossier}'
*/
const FetchDossierSorenirController5eb0e0ae6941c4ef6a1b4418d1793c24 = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierSorenirController5eb0e0ae6941c4ef6a1b4418d1793c24.url(args, options),
    method: 'post',
})

FetchDossierSorenirController5eb0e0ae6941c4ef6a1b4418d1793c24.definition = {
    methods: ["post"],
    url: '/api/partners/fetch-sorenir/{dossier}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierSorenirController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierSorenirController.php
* @route '/api/partners/fetch-sorenir/{dossier}'
*/
FetchDossierSorenirController5eb0e0ae6941c4ef6a1b4418d1793c24.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierSorenirController5eb0e0ae6941c4ef6a1b4418d1793c24.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierSorenirController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierSorenirController.php
* @route '/api/partners/fetch-sorenir/{dossier}'
*/
FetchDossierSorenirController5eb0e0ae6941c4ef6a1b4418d1793c24.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierSorenirController5eb0e0ae6941c4ef6a1b4418d1793c24.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierSorenirController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierSorenirController.php
* @route '/api/dossier/{dossier}/sorenir'
*/
const FetchDossierSorenirController91dc5ad40c478d9ca616b8676266a937 = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierSorenirController91dc5ad40c478d9ca616b8676266a937.url(args, options),
    method: 'get',
})

FetchDossierSorenirController91dc5ad40c478d9ca616b8676266a937.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/sorenir',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierSorenirController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierSorenirController.php
* @route '/api/dossier/{dossier}/sorenir'
*/
FetchDossierSorenirController91dc5ad40c478d9ca616b8676266a937.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierSorenirController91dc5ad40c478d9ca616b8676266a937.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierSorenirController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierSorenirController.php
* @route '/api/dossier/{dossier}/sorenir'
*/
FetchDossierSorenirController91dc5ad40c478d9ca616b8676266a937.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierSorenirController91dc5ad40c478d9ca616b8676266a937.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierSorenirController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierSorenirController.php
* @route '/api/dossier/{dossier}/sorenir'
*/
FetchDossierSorenirController91dc5ad40c478d9ca616b8676266a937.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchDossierSorenirController91dc5ad40c478d9ca616b8676266a937.url(args, options),
    method: 'head',
})

/**
* Multiple routes resolve to \App\Http\Controllers\Dossier\Partners\FetchDossierSorenirController::FetchDossierSorenirController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `FetchDossierSorenirController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const FetchDossierSorenirController = {
    '/api/partners/fetch-sorenir/{dossier}': FetchDossierSorenirController5eb0e0ae6941c4ef6a1b4418d1793c24,
    '/api/dossier/{dossier}/sorenir': FetchDossierSorenirController91dc5ad40c478d9ca616b8676266a937,
}

export default FetchDossierSorenirController